<template>
  <span class="textgrey--text">{{ text }}</span>
</template>

<script>
export default {
  props: {
    text: String,
  },
};
</script>
